var map = {
	"./adobe/": "D6lA",
	"./desktop/": "FfDt",
	"./figma/": "Nuuj",
	"./gsuite/": "cjQn",
	"./office/": "Gcwg",
	"./sketch/": "kbER",
	"./web/": "87J5",
	"./xd/": "69vC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GxMb";